import Landing from './Landing'
import Docs from './Docs'

export default { Landing, Docs };